import React, { useState } from "react";
import { Input } from "rhombus-react";
import {
	WINNER_PERCENTAGE_MIN,
	WINNER_PERCENTAGE_MAX,
	STATISTICAL_SIGNIFICANCE_MIN,
	STATISTICAL_SIGNIFICANCE_MAX,
	MIN_EVENTS_MIN,
	MIN_EVENTS_MAX
} from "utils/constants";

import AdvertiserObjective from "./AdvertiserObjective";

const WINNER_PERCENTAGE = `The percentage allocated to the winner version as a result of auto optimization (Min ${WINNER_PERCENTAGE_MIN}%, Max ${WINNER_PERCENTAGE_MAX}%).`
	, STATISTICAL_SIGNIFICANCE = `The confidence level before automatic optimization is applied (${STATISTICAL_SIGNIFICANCE_MIN}-${STATISTICAL_SIGNIFICANCE_MAX}).`
	, MINIMUM_EVENTS = `The minimum number of events per creative before automatic optimization is applied (${MIN_EVENTS_MIN}-${MIN_EVENTS_MAX}).`
;

function buildMeta(value, min, max) {
	return { valid: value >= min && value <= max, dirty: true };
}

function getError(value, min, max, errorText) {
	return value >= min && value <= max ? null : errorText;
}

export default function StatSigSelection(props){
	const [showAdvancedOptions, setShowAdvancedOptions] = useState(false);

	let {
		onObjective,
		selectedObjective,
		winnerPercentage,
		onWinnerPercentageChange,
		statSigPercentage,
		onStatSigPercentageChange,
		minEvents,
		onMinEventsChange,
		showValidation,
	} = props;

	const handleAdvancedOptionsClick = () => {
		setShowAdvancedOptions(!showAdvancedOptions);
	};

	const winnerPercentageError = showValidation && getError(winnerPercentage, WINNER_PERCENTAGE_MIN, WINNER_PERCENTAGE_MAX, `Value must be between ${WINNER_PERCENTAGE_MIN} and ${WINNER_PERCENTAGE_MAX}`);
	const statSigPercentageError = showValidation && getError(statSigPercentage, STATISTICAL_SIGNIFICANCE_MIN, STATISTICAL_SIGNIFICANCE_MAX, `Percentage must be between ${STATISTICAL_SIGNIFICANCE_MIN} and ${STATISTICAL_SIGNIFICANCE_MAX}`);
	const minEventsError = showValidation && getError(minEvents, MIN_EVENTS_MIN, MIN_EVENTS_MAX, `Value must be between ${MIN_EVENTS_MIN} and ${MIN_EVENTS_MAX}`);

	return (
		<div className="radio-options stat-sig-optimization-options">
			<div className="selector-list">
				<AdvertiserObjective
					onObjective={onObjective}
					selectedObjective={selectedObjective}
					required={showValidation}
					meta={showValidation ? { valid: !!selectedObjective, dirty: true } : undefined}
				/>
			</div>

			<div className="advanced-options-container">
				<button
					type="button"
					className={`advanced-options-button ${showAdvancedOptions ? 'expanded' : ''}`}
					onClick={handleAdvancedOptionsClick}
				>
					<span className="advanced-options-arrow">{showAdvancedOptions ? '▼' : '►'}</span>
					<span className="advanced-options-text">Advanced Options</span>
				</button>
			</div>

			{showAdvancedOptions && (
				<div className="input-with-tooltip">
					<Input
						type="number"
						required
						label="Winner Percentage"
						tip={{
							description: WINNER_PERCENTAGE,
							direction: 'top',
							size: 'large',
						}}
						value={winnerPercentage}
						min = {WINNER_PERCENTAGE_MIN}
						max = {WINNER_PERCENTAGE_MAX}
						onChange={e => onWinnerPercentageChange(Number(e?.target?.value ?? e))}
						meta={showValidation ? buildMeta(winnerPercentage, WINNER_PERCENTAGE_MIN, WINNER_PERCENTAGE_MAX) : undefined}
					/>
					{winnerPercentageError && (
						<span className="stat-sig-field-error">{winnerPercentageError}</span>
					)}
					<Input
						type="number"
						required
						label="Statistical Significance %"
						tip={{
							description: STATISTICAL_SIGNIFICANCE,
							direction: 'top',
							size: 'large',
						}}
						value={statSigPercentage}
						min = {STATISTICAL_SIGNIFICANCE_MIN}
						max = {STATISTICAL_SIGNIFICANCE_MAX}
						onChange={e => onStatSigPercentageChange(Number(e?.target?.value ?? e))}
						meta={showValidation ? buildMeta(statSigPercentage, STATISTICAL_SIGNIFICANCE_MIN, STATISTICAL_SIGNIFICANCE_MAX) : undefined}
					/>
					{statSigPercentageError && (
						<span className="stat-sig-field-error">{statSigPercentageError}</span>
					)}
					<Input
						type="number"
						required
						label="Minimum Events"
						tip={{
							description: MINIMUM_EVENTS,
							direction: 'top',
							size: 'large',
						}}
						value={minEvents}
						min = {MIN_EVENTS_MIN}
						max = {MIN_EVENTS_MAX}
						onChange={e => onMinEventsChange(Number(e?.target?.value ?? e))}
						meta={showValidation ? buildMeta(minEvents, MIN_EVENTS_MIN, MIN_EVENTS_MAX) : undefined}
					/>
					{minEventsError && (
						<span className="stat-sig-field-error">{minEventsError}</span>
					)}
				</div>
			)}
		</div>
	);
}
